export default __webpack_public_path__ + "static/media/game.c5cce56e.png";